// Modules
import React from "react";

// Styles
import "./MvFilterBtn.sass";

type Props = {
  onClick(): void;
}

class MvFilterBtn extends React.Component<Props> {

  render() {
    const {onClick} = this.props;

    return (
      <button className="mv-filter-btn" onClick={onClick}>
        <span className="text">{"Filter"}</span>
        <span className="filter-icon"/>
      </button>
    );
  }
}

export default MvFilterBtn;
